import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import * as yup from 'yup';
import cx from 'classnames';
import noop from 'lodash/noop';
import storage from 'web-storage';

import Icon from 'common/icon';
import Button from 'common/button';

const { localStorage } = storage();

class ForgotPasswordForm extends Component {
    initialValues = {
        email: localStorage.get('authUser.email') || '',
    };

    validate = yup.object().shape({
        email: yup
            .string()
            .email()
            .required(),
    });

    static propTypes = {
        requestPasswordReset: PropTypes.func.isRequired,
        showFlash: PropTypes.func.isRequired,
        onSubmit: PropTypes.func,
    };

    static defaultProps = {
        onSubmit: noop,
    };

    handleSubmit = async (values, { setSubmitting }) => {
        const { requestPasswordReset, showFlash, onSubmit } = this.props;

        try {
            localStorage.set('authUser.email', values.email);
            await requestPasswordReset({ variables: values });
            showFlash({
                type: 'info',
                title: 'Success!',
                message: 'You should receive your reset link shortly.',
                duration: 5000,
            });

            setSubmitting(false);
            onSubmit();
        } catch (err) {
            setSubmitting(false);
            showFlash({
                type: 'danger',
                title: 'Woops!',
                message:
                    "Something went wrong with your request. Are you sure that's the correct email address?",
                duration: 5000,
            });
        }
    };

    render() {
        return (
            <Formik
                initialValues={this.initialValues}
                validationSchema={this.validate}
                onSubmit={this.handleSubmit}
            >
                {({ isSubmitting, touched, errors }) => (
                    <Form>
                        <Field
                            type="email"
                            name="email"
                            placeholder="Email"
                            className={cx('input-default w-full', {
                                'is-invalid': touched.email && errors.email,
                            })}
                        />
                        <Button
                            type="submit"
                            color="green"
                            size="md"
                            className={cx('block w-full font-bold uppercase tracking-wide mt-12', {
                                'pointer-events-none opacity-60': isSubmitting,
                            })}
                        >
                            {isSubmitting ? (
                                <Icon icon="spinner" size="lg" className="leading-none" spin />
                            ) : (
                                'Send Reset Link'
                            )}
                        </Button>
                    </Form>
                )}
            </Formik>
        );
    }
}

export default ForgotPasswordForm;
